import type { ExternalCue } from '../player.config';
import type { VideoJsPlayer } from 'video.js';

import { useCallback, useMemo } from 'react';

import { floor } from '../../../utils/math';
import { VideoJsCustomEvent } from '../videojs-event';
import { useCustomCues } from './use-custom-cues';

export function useExternalCues(player: VideoJsPlayer, externalCues: ExternalCue[] | undefined) {
  const cues = useMemo(() => {
    if (!externalCues) {
      return [];
    }

    return externalCues.map((cue) => {
      const time = floor(cue.time, 0.25);
      const newCue = new VTTCue(time, time + 0.25, JSON.stringify(cue.value));
      newCue.id = cue.id ?? cue.time.toString();
      return newCue;
    });
  }, [externalCues]);

  const onCueChange = useCallback(
    (cues: TextTrackCue[]) => {
      for (const cue of cues) {
        player.trigger(VideoJsCustomEvent.CUEPOINT, {
          cuepoint: {
            id: cue.id,
            time: cue.startTime,
            value: JSON.parse((cue as VTTCue).text),
          },
        });
      }
    },
    [player]
  );

  useCustomCues({
    player,
    cues,
    onCueChange,
    textTrackLabel: 'External Cues',
  });
}
